const cardTypes = [{
    "label": "Yellow",
    "id": "Yellow"
}, {
    "label": "Blue",
    "id": "Blue"
}, {
    "label": "Red",
    "id": "Red"
}, {
    "label": "Green",
    "id": "Green"
}];

export const addResponsibility = ({ form }) => {
    form.setConfig({
        "title": "Add Responsibility",
        "type": "push",
        "location": "Database/EngineerResponsibilities",
        "fields": [{
            "label": "Responsibility",
            "name": "Responsibility",
            "type": "text"
        }, {
            "label": "Card Colours",
            "type": "dropdown",
            "multiple": true,
            "dropdownData": cardTypes,
            "name": "Colours"
        }]
    });
    form.getDropdownData();
    form.toggle();
};

export const editResponsibility = ({ form, rowItem }) => {
    form.setValues(rowItem);
    form.setConfig({
        "title": "Edit Responsibility",
        "type": "update",
        "location": `Database/EngineerResponsibilities/${rowItem.ID}`,
        "fields": [{
            "label": "Responsibility",
            "name": "Responsibility",
            "type": "text"
        }, {
            "label": "Card Colours",
            "type": "dropdown",
            "dropdownData": cardTypes,
            "multiple": true,
            "name": "Colours"
        }]
    });
    form.getDropdownData();
    form.toggle();
};

export const deleteResponsibility = ({ form, rowItem }) => {
    form.setConfig({
        "title": "Delete Responsibility",
        "type": "delete",
        "location": `Database/EngineerResponsibilities/${rowItem.ID}`,
        "description": "Are you sure you want to delete this responsibility?",
        "fields":[]
    });
    form.toggle();

}
